module.exports = __webpack_public_path__ + "static/media/TvShowBanner (4).cef358cd.png";